import TrawickPlanIds from '../../../helper-functions/companies/trawick-planids';

const trawickPlanIds = new TrawickPlanIds();

export { trawickPlanIds };
